import React from 'react';
import TemplatePreview from './TemplatePreview';

export const TemplatePreviewPage: React.FC = () => (
  <>
    <TemplatePreview />
  </>
);

export default TemplatePreviewPage;
